import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const Section = ({ title, children }) => (
  <section className="pp-section">
    {title && <h3 className="pp-subheading">{title}</h3>}
    <div className="pp-body">{children}</div>
  </section>
);

const List = ({ items }) => (
  <ul className="pp-list">
    {items.map((i, idx) => (
      <li key={idx}>{i}</li>
    ))}
  </ul>
);

const PrivacyPolicy = () => {
  return (
    <>
      <div className="pp-hero">
        <div className="pp-titlebar">
          <h1 className="pp-title">Privacy Policy</h1>
        </div>
      </div>
      <div className="pp-wrapper">
        <div className="pp-card">
          <p className="pp-updated">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          <hr className="pp-divider" />

          <Section>
            <p>
              RELAY is vigilant to safeguard your privacy. It is crucial that
              our customers as well as all other stakeholders in our ecosystem
              are entitled to maintain their privacy while doing transactions or
              otherwise leveraging our products / services. To ensure this we
              follow the basic steps outlined below.
            </p>
            <List
              items={[
                "We have in place systems and processes which ensure your personal information remains strictly private.",
                "All information collected is maintained in electronic form on servers and/or cloud systems and shall be accessible by certain employees of the Company.",
                "We do not share or otherwise make available any of your personal information (names, addresses, card numbers, transaction history) without your express permission.",
                "Despite employing cookie technology to help users navigate, we do not use this technology to store any personal information.",
              ]}
            />
            <p>
              However, please note that our website might contain links to other
              websites, the privacy practices of which might differ from ours.
            </p>
          </Section>

          <Section title="Security Measures">
            <p>
              The Company has implemented security policies, rules and technical
              measures, as required under applicable law including firewalls,
              transport layer security and other physical and electronic
              security measures to protect the financial and personal
              information under its control from unauthorized access, improper
              use or disclosure, unauthorized modification and unlawful
              destruction or accidental loss. The Company shall not be
              responsible for any breach of security or for any action of third
              parties or events beyond reasonable control.
            </p>
          </Section>

          <Section title="Location Data">
            <p>
              When a User visits or uses the Platforms, the Company may access,
              collect, monitor and/or remotely store data in relation to the
              User’s location, which may also include GPS coordinates or similar
              information regarding the location of the device. The location
              data does not collect or share any personally identifiable
              information about the User.
            </p>
          </Section>

          <Section title="Cookies">
            <p>
              A User may disable cookies in the browser; doing so may impair or
              restrict access to certain areas of the Platforms. Users are
              encouraged to use the “clear cookies” functionality of their
              browsers to ensure deletion.
            </p>
          </Section>

          <Section title="This privacy policy intends to ensure:">
            <List
              items={[
                "That you have complete mental assurance while surfing/using our platforms, and opening any link and download any file",
                "That you feel totally secure while sharing any personal information with us",
                "That you understand and are in consent to share certain data essentially in order to serve you better, while maintaining your privacy",
              ]}
            />
          </Section>

          <Section title="Information which might be collected from you">
            <h4 className="pp-minihead">Deemed consent by user</h4>
            <p>
              By accessing our website/Portal/Platform, you consent to the terms
              and conditions of the policy. We may collect additional
              information in connection with your participation in promotions,
              contests, events or campaigns as a loyal customer / member,
              including feedback, suggestions and complaints.
            </p>
            <p>
              As you use our platform, certain information may be automatically
              gathered via standard usage logs and cookies:
            </p>
            <List
              items={[
                "System / mobile device-identification data",
                "IP addresses",
                "Domain server and type of web browser",
                "Type of system / device used",
              ]}
            />
          </Section>

          <Section title="RELAY uses your personal information to:">
            <List
              items={[
                "Improve your experience by offering personalized features",
                "Reach out for matters pertaining to your profile and mutual interest",
                "Render services pertaining to your queries / suggestions",
                "Store historical data as mandated by applicable laws / regulations",
              ]}
            />
          </Section>

          <Section title="RELAY uses anonymous traffic information to:">
            <List
              items={[
                "Remember your preferences to provide better, personalized services",
                "Monitor and manage seamless functionality by identifying issues",
                "Keep a record of sessions and surfing habits to enhance user experience",
              ]}
            />
          </Section>

          <Section title="Update or Amendment of this policy">
            <p>
              The User’s visit to and/or use of the Platforms and any dispute
              over privacy is subject to this Privacy Policy and the Terms of
              Use. The Company may update and/or amend this Privacy Policy at
              any time, with or without advance notice. Users should review the
              terms from time to time.
            </p>
          </Section>

          <div className="pp-actions">
            <Link to="/" className="pp-link">
              ← Back to Login
            </Link>
            <a
              href="https://relay.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="pp-source"
            >
              Source policy
            </a>
          </div>
        </div>
      </div>
      <footer className="pp-footer">
        <div className="pp-footer-inner">
          <span className="pp-footer-copy">
            © {new Date().getFullYear()} RELAY, All Rights Reserved
          </span>
          <nav className="pp-footer-links">
            <Link to="/" className="pp-link">
              Back to Login
            </Link>
            <a
              href="https://relay.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="pp-link"
            >
              Official Policy
            </a>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default PrivacyPolicy;
